// extracted by mini-css-extract-plugin
export var mobileOnly = "mobile_only-module--mobileOnly--TD9iJ";